import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDataContext } from "../../context/DataContext";
import TabsContent from "../TabsContent/TabsContent";

function RequestDetails() {
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();

  const { id } = params;

  const { data } = useDataContext();

  const { row } = location.state || {};

  useEffect(() => {
    if (!row) {
      // return <Missing />;
      navigate("/requests", { replace: true });
    }
  }, [row]);

  if (row && id && data) {
    const request = data.find((x) => x.id_F === parseInt(id, 10));
    return <TabsContent request={request} />;
  }

  return null;
}

export default RequestDetails;
